import React, { useState } from 'react'
import Swal from 'sweetalert2';
import { useHistory } from "react-router-dom";
import { Translate } from '../../../language'
import ImageNameDescription from '../../../utils/components/ImageNameDescription/ImageNameDescription'
import circle from '../../../assets/img/circulogris.png';
import './Notifications.css'
import { AcceptIcon, CloseIcon } from '../../../assets/icons';
import { acceptFriendRequest, cancelFriendRequest } from '../../../actions/friendsActions';
import { useDispatch } from 'react-redux';
import IconeDescription from '../../../utils/components/iconDescription/IconDescription';
import { deleteNotification, viewNotification } from '../../../actions/notificationsActions';
import { acceptCommunityRequest, apeleReport, manageSocialRoom, rejectCommunityRequest } from '../../../actions/userActions';
import inMemoryJwt from '../../../auth/inMemoryJwt';
import useModal from '../../../utils/hooks/useModal';
import InputTextArea from '../../../utils/components/InputTextArea/InputTextArea';
import Button from '../../../utils/components/Button/Button';

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1000
})

const Notifications = ({
    setisViewNotification = () => { },
    setIsShowNotification,
    isLoadingNotificationsAddresse,
    listNotifications = [],
    isProfessionalUser,
    isViewNotification,
}) => {
    const history = useHistory()
    const dispatch = useDispatch()
    const [refModaReport, isShowReport, setIsShowReport] = useModal(false)
    const [objection, setObjection] = useState(null)
    const [dataInfo, setDataInfo] = useState(null)
    const showNotification = (data, index, isRequest) => {
        var isView = data.doYouSeeTheNotification
        var messageNotification = data.notification ///+ " " + data.whoIsNotified
        var nameSender = ""
        var urlSender = circle
        var idSender = ""
        var idProfileSender = ""
        var lastnameSender = ""
        var nextStep = null
        var isEnableContent = true
        var notificationType = data.whoIsNotified

        if (data.infoSender) {
            switch (data.infoSender.type) {
                case "user":
                    idSender = data.infoSender._id
                    idProfileSender = data.infoSender._id
                    nameSender = data.infoSender.name
                    lastnameSender = data.infoSender.lastname
                    urlSender = (data.infoSender.picture && data.infoSender.picture.url) ? data.infoSender.picture.url.small ? data.infoSender.picture.url.small : data.infoSender.picture.url.origin : circle
                    break;
                case "franchise":
                    idSender = data.infoSender.userID
                    idProfileSender = data.infoSender._id
                    nameSender = data.infoSender.socialReason
                    urlSender = (data.infoSender.picture && data.infoSender.picture.url) ? data.infoSender.picture.url.small ? data.infoSender.picture.url.small : data.infoSender.picture.url.origin : circle
                    break
                case "warehouse":
                    nameSender = data.infoSender.name
                    idSender = data.infoSender.profileId._id
                    idProfileSender = data.infoSender._id
                    urlSender = (data.infoSender.profileId.picture && data.infoSender.profileId.picture.url) ? data.infoSender.profileId.picture.url.small ? data.infoSender.profileId.picture.url.small : data.infoSender.profileId.picture.url.origin : circle
                    break
                case "representative":
                    idSender = data.infoSender.userID._id
                    idProfileSender = data.infoSender._id
                    nameSender = data.infoSender.userID.name || data.infoSender.name
                    lastnameSender = data.infoSender.userID.lastname || ""
                    urlSender = (data.infoSender.userID.picture && data.infoSender.userID.picture.url) ? data.infoSender.userID.picture.url.small ? data.infoSender.userID.picture.url.small : data.infoSender.userID.picture.url.origin : circle
                    break
                default:
                    break;
            }

        }



        switch (true) {
            case notificationType === "PRI":

                messageNotification = "Se eliminaron existencias de productos"
                break
            case notificationType === "PQRS":
                nameSender = ""
                const type = Translate(data.pqrsId.type, "es")

                nextStep = "/UserPQRS"
                isEnableContent = true
                const status = data.pqrsId.status
                if (status === 1) {
                    messageNotification = `se respondió tu ${type}`
                } else {
                    messageNotification = `se resolvió tu ${type}`
                }


                break
            case notificationType === "RMA":
                messageNotification = "Acepto tu invitación a sala"
                break
            case notificationType === "ZMA":
                messageNotification = "Acepto tu invitación a zona"
                break
            case notificationType === "NCR":
                nameSender = ""
                messageNotification = "Contenido reportado"
                break
            case notificationType === "PDA":
                messageNotification = "Se está agotando un producto"
                if (data.generalInventoryId) {
                    nextStep = "/Inventory/Inventory"
                }
                break
            case notificationType === "NRP":
                messageNotification = "reporto tu publicación"
                if (data.zoneReportId && data.zoneReportId.zonePostID) {
                    nextStep = `/Zones/Post/${data.zoneReportId.zonePostID._id}`
                }
                break
            case notificationType === 'NLLS':
                messageNotification = data.notification

                break
            case notificationType === 'NMR':
                messageNotification = "Se retiro de tu Zona"
                nextStep = `/Zones/Admin/${data.zoneId}/Members`
                break
            case notificationType === 'NNP':
                messageNotification = "Ha Publicado en tu Zona"
                if (data.zonePostId && data.zonePostId._id) {
                    nextStep = `/Zones/Post/${data.zonePostId._id}`
                } else {
                    isEnableContent = false
                }

                break
            case notificationType === "NOD":
                const liters = data?.oilRegisterId?.liters
                const ecos = data?.oilRegisterId?.ecosReceived
                messageNotification = `Ha Registrado tu entrega de ${liters} litro${liters > 1 ? "s" : ""} de aceite, ganaste ${ecos} eco${ecos > 1 ? "s" : ""}`
                break
            case notificationType === "NMP":
                messageNotification = "Ya puedes reclamar tu producto con QR"
                nextStep = `/payment/success?preference_id=${data.paymentId.preference_id}&token=${inMemoryJwt.getToken()}`
                break
            case notificationType === "A1":
                nameSender = data.name
                // urlSender = data.infoSender.profilePicture ? data.infoSender.profilePicture : circle
                messageNotification = "Ha solicitado validar un certificado"
                break;
            case notificationType === "U1" || notificationType === "M1" || notificationType === "P1":
                messageNotification = "Tu certificado ha sido validado"
                break;
            case notificationType === "U2" || notificationType === "M2" || notificationType === "P2":
                messageNotification = "Te ha etiquetado en una publicación "
                if (data.postId || data.ProfessionalPostsId)
                    nextStep = `${isProfessionalUser ? '/Professional/Post/' : '/Post/'}` + data.postId._id
                else (
                    isEnableContent = false
                )
                break;
            case notificationType === "NC":
                messageNotification = "Ha comentado tu publicación "
                if (data.postId) {
                    if (data.postId?.multimedia?.type.includes("hls")) {
                        nextStep = '/Stream/' + data.postId._id
                    } else {
                        nextStep = '/Post/' + data.postId._id
                    }
                }
                else (
                    isEnableContent = false
                )
                break;

            case notificationType === "NR":




                if (data.postId) {
                    messageNotification = "Ha reaccionado a tu publicación."
                    if (data.postId?.multimedia?.type.includes("hls")) {
                        nextStep = '/Stream/' + data.postId._id
                    } else {
                        nextStep = '/Post/' + data.postId._id
                    }
                }
                if (data.commentId) {
                    messageNotification = "Ha reaccionado a tu comentario."
                    if (data.reactionId.commentID.postID?.multimedia?.type.includes("hls")) {
                        nextStep = '/Stream/' + data.reactionId.commentID.postID._id
                    } else {
                        nextStep = '/Post/' + data.reactionId.commentID.postID._id
                    }
                }
                else (
                    isEnableContent = false
                )
                break;
            case notificationType === "NSP":
                messageNotification = "Ha compartido tu publicación."
                if (data.postId) {
                    if (data.postId?.multimedia?.type.includes("hls")) {
                        nextStep = '/Stream/' + data.postId._id
                    } else {
                        nextStep = '/Post/' + data.postId._id
                    }
                }
                else (
                    isEnableContent = false
                )
                break;

            case notificationType === "U9" || notificationType === "P9":
                nextStep = `${isProfessionalUser ? '/Professional' : ''}/Communities/Community/` + data.communityId._id
                messageNotification = `Te han asignado como ${data.assignedRoleId ? data.assignedRoleId.name : 'usuario normal'} en la comunidad ` + data.communityId.name
                break;
            case notificationType === "U10" || notificationType === "M10" || notificationType === "P10":
                if (data.userBadgeId && data.userBadgeId.awardID && data.userBadgeId.awardID.image)
                    urlSender = data.userBadgeId.awardID.image.url
                messageNotification = "Has obtenido una nueva insgnia/premio"
                break;
            case notificationType === "P13":
                nameSender = "Comunidad"
                messageNotification = "Han aceptado tu publicación en "
                break;
            case notificationType === "NSA":
                messageNotification = "Quiere ser tu EcoAmigo"
                if (idSender)
                    nextStep = `/Profile/` + idSender
                else (
                    isEnableContent = false
                )
                break;
            case notificationType === "NSAA":
                messageNotification = "Ha aceptado tu solicitud de amistad"
                // isRequest = false
                break;
            case notificationType === "NIM":
                if (data.zoneId.adminUserId === idProfileSender)
                    messageNotification = "Te ha invitado a unirte a una zona"
                else
                    messageNotification = "ha enviado una solicitud a tu zona"
                break;
            case notificationType === "NSSC":
                if (data.chatConnectionId) {
                    if (data.chatConnectionId.adminID === idProfileSender)
                        messageNotification = "Te ha invitado a unirte a una sala"
                    else
                        messageNotification = "han enviado una solicitud a tu sala"
                }
                else (
                    isEnableContent = false
                )
            default:
                break;
        }
        if (isView) return <></>
        return <div key={data._id}>
            {!isRequest ? //si es una notificacion normal
                <IconeDescription
                    key={data._id}
                    onClick={() => {
                        if (notificationType != "NCR") {
                            dispatch(viewNotification(data._id, nextStep))
                            setisViewNotification(prevState => { return { ...prevState, [data._id]: true } })
                            if (!isViewNotification[data._id]) {

                            }

                            else if (!isEnableContent)
                                Toast.fire({
                                    icon: 'error',
                                    title: 'Contenido no disponible'
                                })
                            if (nextStep) {
                                history.push(nextStep)
                                setIsShowNotification(false)
                            }

                        } else {
                            setDataInfo(data)
                            setIsShowReport(true)
                        }
                    }}
                    icon={notificationType}

                    firstName={nameSender.split(' ')[0]}
                    secondName={lastnameSender.split(' ')[0]}
                    shouldDscriptionEllipsis={false}

                    description={nameSender + " " + messageNotification}
                />
                : //si es una notificacion de solicitud ( que se puede aceptar o rechazar)
                <div key={data._id} style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ flexGrow: "1" }}>

                        <ImageNameDescription
                            key={data._id}
                            onClick={() => {

                                if (notificationType != "U16") {
                                    if (!isViewNotification[data._id])
                                        if(notificationType=="NSAA"){
                                            dispatch(viewNotification(data._id))
                                        }
                                    else if (!isEnableContent)
                                        Toast.fire({
                                            icon: 'error',
                                            title: 'Contenido no disponible'
                                        })
                                    if (nextStep) {
                                        history.push(nextStep)
                                        setIsShowNotification(false)
                                    }
                                    setisViewNotification(prevState => { return { ...prevState, [data._id]: true } })
                                }
                            }}
                            srcImage={urlSender}
                            firstName={nameSender}
                            secondName={lastnameSender}
                            shouldDscriptionEllipsis={false}
                            description={messageNotification}
                        />
                    </div>
                    {
                        isRequest && (
                            <RequestOptions idSender={idProfileSender} data={data} notificationType={notificationType} setisViewNotification={setisViewNotification} />
                        )
                    }
                </div>

            }
        </div>
    }
    console.log();
    return (
        <div style={{ overflow: 'auto' }} onClick={(e) => { e.stopPropagation() }} className='scroll-menu content-notifications'>
            {(listNotifications.request.filter(data => !data.doYouSeeTheNotification).length === 0 && listNotifications.othersNotifications.filter(data => !data.doYouSeeTheNotification).length === 0) && (
                <div className="">Estas al dia</div>
            )}

            {listNotifications.request.filter(data => !data.doYouSeeTheNotification).length > 0 && (
                <div className="title-notifications">
                    {Translate('requests', 'es')}
                </div>
            )}
            {!isLoadingNotificationsAddresse && listNotifications.request.filter(data => !data.doYouSeeTheNotification).length > 0 ? listNotifications.request.map((data, index) =>
                showNotification(data, index, true)
            ) :
                <div className=""></div>
            }

            {!isLoadingNotificationsAddresse && listNotifications.othersNotifications.filter(data => !data.doYouSeeTheNotification).length > 0 && (
                <div className="title-notifications">
                    {Translate('notifications', 'es')}
                </div>
            )}

            {listNotifications.othersNotifications.filter(data => !data.doYouSeeTheNotification).length > 0 ? listNotifications.othersNotifications.filter(data => data.doYouSeeTheNotification === false).map((data, index) =>
                showNotification(data, index, false)
            ) :
                <div className=""></div>
            }

            {listNotifications.paymentsNotifications.length > 0 && (
                <div className="title-notifications">
                    {Translate('paymentNotifications', 'es')}
                </div>
            )}
            {listNotifications.paymentsNotifications.length > 0 ? listNotifications.paymentsNotifications.map((data, index) =>
                showNotification(data, index, false)
            ) :
                <div className=""></div>
            }
            {listNotifications.pqrsNotifications.length > 0 && (
                <div className="title-notifications">
                    {Translate('PQRS', 'es')}
                </div>
            )}
            {listNotifications.pqrsNotifications.length > 0 ? listNotifications.pqrsNotifications.map((data, index) =>
                showNotification(data, index, false)
            ) :
                <div className=""></div>
            }
            {
                isShowReport && (
                    <div className='modal'>
                        <div className='modal-content' >
                            Tu contenido fue reportado. deseas apelar
                            <InputTextArea setValue={(value) => {
                                {
                                    setObjection(value)
                                }
                            }} />
                            <Button text='Aceptar' onClick={e => {
                                dispatch(apeleReport(dataInfo.contentReportId, objection, () => {
                                    dispatch(viewNotification(dataInfo._id))
                                    setisViewNotification(prevState => { return { ...prevState, [dataInfo._id]: true } })
                                    setDataInfo(null)
                                }))
                            }} />
                            <Button text='Enviar' onClick={e => {
                                dispatch(apeleReport(dataInfo.contentReportId, objection, () => {
                                    dispatch(viewNotification(dataInfo._id))
                                    setisViewNotification(prevState => { return { ...prevState, [dataInfo._id]: true } })
                                    setDataInfo(null)
                                }))
                            }} />
                        </div>
                    </div>
                )
            }
        </div>
    )
}
const RequestOptions = ({ idSender, data, notificationType, setisViewNotification }) => {
    const dispatch = useDispatch()
    const handleAcccept = (e) => {
        e.preventDefault(); e.stopPropagation();
        dispatch(viewNotification(data._id))
        setisViewNotification(prevState => { return { ...prevState, [data._id]: true } })
        switch (notificationType) {
            case "NSA":
                dispatch(acceptFriendRequest(idSender))
                break
            case 'NSSC':

                dispatch(manageSocialRoom({
                    chatRoomID: data.chatConnectionId.chatRoomID,
                    entityID: (data.chatConnectionId.sendRequest) ? idSender : data.addresseeID,
                    type: 2
                }))
                break;
            case "NIM":
                dispatch(acceptCommunityRequest(data.memberId._id, true))
                break
            default:
                break;
        }
    }
    const handleReject = (e) => {
        e.preventDefault(); e.stopPropagation();
        dispatch(viewNotification(data._id))
        setisViewNotification(prevState => { return { ...prevState, [data._id]: true } })
        switch (notificationType) {
            case "NSA":
                dispatch(cancelFriendRequest(idSender))
                break;
            case 'NSSC':
                dispatch(manageSocialRoom({
                    chatRoomID: data.chatConnectionId.chatRoomID,
                    entityID: (data.chatConnectionId.sendRequest) ? idSender : data.addresseeID,
                    type: 3
                }))
            case "NIM":
                dispatch(rejectCommunityRequest(data.memberId._id, true))
                break
            default:
                break;
        }

    }
    if (notificationType === "NSAA") {
        return <></>
    }
    return <div style={{ display: "flex" }}>
        <div onClick={handleAcccept} className='circle-accept'>
            <AcceptIcon className="icon-option-notification" />
        </div>
        <div onClick={handleReject} className='circle-reject'>
            <CloseIcon className="icon-option-notification" />
        </div>
    </div>
}
export default Notifications
